// useNotificationPreferences.js (Custom Hook)
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { createTasks, participateTasks, tasksReported, reportTask} from "../../constants/notification";
import { toast } from "react-toastify";
import CustomToast from '../../components/CustomToast';


const useNotificationPreferences = ({ setLoading, setViaWebBool, setViaEmailBool }) => {
    const [preferences, setPreferences] = useState({ participateTasks: [], createTasks: [], tasksReported: [], reportTask:[] });

    // console.log(preferences, "preferencespreferencespreferencespreferencespreferencespreferences");

    const fetchPreferences = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}settings/preferences/notfication`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            const userPreferences = response.data.data.preferences;

            const updateTasks = (tasks) => tasks.map(task => {
                const pref = userPreferences.find(p => p.description === task.description);
                return { ...task, viaWeb: pref ? pref.viaWeb : false, viaEmail: pref ? pref.viaEmail : false };
            });

            setPreferences({
                participateTasks: updateTasks(participateTasks),
                createTasks: updateTasks(createTasks),
                  tasksReported: updateTasks(tasksReported),
                  reportTask: updateTasks(reportTask)
            });

        } catch (error) {
            console.error("Error fetching preferences:", error);
        } finally {
            setLoading(false);
        }
    };

    // const togglePreference = (taskType, taskId, key) => {
    //     setPreferences(prev => {
    //         const updatedTasks = prev[taskType].map(task =>
    //             task.id === taskId ? { ...task, [key]: !task[key] } : task
    //         );
    //         return { ...prev, [taskType]: updatedTasks };
    //     });
    // };

    const togglePreference = (taskType, taskId, key) => {
        setPreferences(prev => {
            const updatedTasks = prev[taskType].map(task =>
                task.id === taskId ? { ...task, [key]: !task[key] } : task
            );

            const newPreferences = { ...prev, [taskType]: updatedTasks };

            // Calculate if any task uses viaWeb or viaEmail
            const anyViaWeb = Object.values(newPreferences).some(taskGroup =>
                taskGroup.some(task => task.viaWeb)
            );

            const anyViaEmail = Object.values(newPreferences).some(taskGroup =>
                taskGroup.some(task => task.viaEmail)
            );

            // Update external booleans
            setViaWebBool(anyViaWeb);
            setViaEmailBool(anyViaEmail);

            return newPreferences;
        });
    };

    const savePreferences = async (navigate) => {
        const accessToken = localStorage.getItem("accessToken");
        const payload = {
            preferences: [...preferences.participateTasks, ...preferences.createTasks, ...preferences.tasksReported , ...preferences.reportTask].map(({ id, viaWeb, viaEmail }) => ({ id, viaWeb, viaEmail }))
        };
        try {
            setLoading(true);
            await axios.patch(`${API_URL}settings/preferences/notfication`, payload, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            // navigate("/allnotification");
            // navigate("/notificationpreferences");
            // toast?.success("Preferences saved successfully")
            CustomToast.show('success', 'Success!', 'Preferences saved successfully')

            console.log("Preferences saved successfully");
            setViaWebBool(false);

        } catch (error) {
            console.error("Error saving preferences:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPreferences();
    }, []);

    return { preferences, togglePreference, savePreferences };
};

export default useNotificationPreferences;
